<template>
  <el-form class="searchPanel">
    <el-row type="flex">
      <el-col :span="11">
        <el-form-item label="知识分类"
                      label-width="90px"
                      label-position="right"
                      class="searchField">
          <commonSelectComponent @getValue="getKnowledgeClassValue"
                                 @setValue="setKnowledgeClassValue"
                                 :myOption="knowledgeClassOption"
                                 :myData="knowledgeClass"
                                 ref="cs1"></commonSelectComponent>
        </el-form-item>
      </el-col>
      <el-col :span="11">
        <el-form-item label="知识类型"
                      label-width="90px"
                      label-position="right"
                      class="searchField">
          <commonSelectComponent @getValue="getKnowledgeTypeValue"
                                 @setValue="setKnowledgeTypeValue"
                                 :myOption="knowledgeTypeOption"
                                 :myData="knowledgeType"
                                  ref="cs2"></commonSelectComponent>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row type="flex">
      <el-col :span="11">
        <el-form-item label="产品对象"
                      label-width="90px"
                      label-position="right"
                      class="searchField">
          <commonSelectComponent @getValue="getProductModelValue"
                                 @setValue="setProductModelValue"
                                 :myOption="productModelOption"
                                 :myData="productModel"
                                  ref="cs3"></commonSelectComponent>
        </el-form-item>
      </el-col>
      <el-col :span="11">
        <el-form-item label="对象实例"
                      label-width="90px"
                      label-position="right"
                      class="searchField">
          <commonSelectComponent :myOption="optionSelKnowledgeObj"
                                 :myData="dataSelKnowledgeObj"
                                 @getValue="GetKnowledgeDevice"
                                 @setValue="setKnowledgeDevice"
                                  ref="cs4">
          </commonSelectComponent>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>

</template>

<script>
import {
  GetAllKnowledgeClass,
  GetAllKnowledgeType,
  GetAllObjTypeBSMV,
  GetAllGeneralSelTreeEx
} from '@/api/modules/basicData/knowledge'
import { Linq } from '@/util/common'
import commonSelectComponent from '@/components/basicData/commonSelectComponent.vue'
import { getToken } from "../../util/auth";
const cookieUser = getToken();
export default {
  data() {
    return {
      knowledgeClassOption: {
        commomShowPlaceholder: '请选择知识分类', //输入框默认提示
        commonDialogTitle: '请选择知识分类', //弹出窗标题
        commonCheckedDescription: '请选择知识分类', //右侧table标题
        isRadio: true //单双选
      },
      knowledgeClass: {
        //知识分类
        idArray: [],
        imageType: [],
        checkField: {
          Id: 'ID', //区别上下级
          Pid: 'PID',
          Key: 'ID', //数据标识，相同key则为同一条数据（例如不同组织下同一人）
          Type: 'ENABLE', //类型区别字段如Type
          TypeValue: [true], //有效的type值
          ValidField: ['NAME'], //可搜索字段
          ShowField: 'NAME', //确认后显示字段
          ShowFieldName: ''
        }
      },
      knowledgeTypeOption: {
        commomShowPlaceholder: '请选择知识类型', //输入框默认提示
        commonDialogTitle: '请选择知识类型', //弹出窗标题
        commonCheckedDescription: '请选择知识类型', //右侧table标题
        isRadio: true //单双选
      },
      knowledgeType: {
        //知识类型
        idArray: [],
        imageType: [],
        checkField: {
          Id: 'ID', //区别上下级
          Pid: 'NAME',
          Key: 'ID', //数据标识，相同key则为同一条数据（例如不同组织下同一人）
          Type: 'ENABLE', //类型区别字段如Type
          TypeValue: [true], //有效的type值
          ValidField: ['NAME'], //可搜索字段
          ShowField: 'NAME', //确认后显示字段
          ShowFieldName: ''
        }
      },
      productModelOption: {
        commomShowPlaceholder: '请选择产品型号', //输入框默认提示
        commonDialogTitle: '请选择产品型号', //弹出窗标题
        commonCheckedDescription: '请选择产品型号', //右侧table标题
        isRadio: true //单双选
      },
      productModel: {
        //知识类型
        idArray: [],
        imageType: [],
        checkField: {
          Id: 'Id', //区别上下级
          Pid: 'Pid',
          Key: 'Id', //数据标识，相同key则为同一条数据（例如不同组织下同一人）
          Type: 'Enable', //类型区别字段如Type
          TypeValue: [true], //有效的type值
          ValidField: ['Name'], //可搜索字段
          ShowField: 'Name', //确认后显示字段
          ShowFieldName: ''
        }
      },
      //选择对象实例
      dataSelKnowledgeObj: {
        idArray: [],
        imageType: [],
        checkField: {
          Id: 'Id',
          Pid: 'Pid',
          Key: 'AggrID',
          Type: 'Type',
          TypeValue: [
            20,
            31,
            21,
            22,
            23,
            41,
            43,
            45,
            47,
            49,
            24,
            25,
            29,
            12,
            14,
            16,
            33,
            35,
            37,
            39
          ],
          ValidField: ['Name', 'Ips', 'PY', 'FullPY'],
          ShowField: 'Name',
          ShowFieldName: '对象实例',
          FiledList: ['Ips']
        }
      },
      optionSelKnowledgeObj: {
        commomShowPlaceholder: '',
        commonDialogTitle: '选择对象实例',
        commonCheckedDescription: '对象实例',
        isRadio: true,
        setWidth: '100%',
        //searchContainsSubsets:true, //搜索后是否包含子级
        isStrictly: true //父子节点不关联
      },

      searchPara: {
        KNOWLEDGECLASS: '', //知识分类
        KNOWLEDGETYPE: '', //知识类型
        Product: '', //产品
        Opobject: '', //运维对象
        SortStyle: 0, //排序
        Device: {}, //对象实例
         CurPerson: {
          ID: cookieUser.userId,
          NAME: cookieUser.realName,
          DEPTID: cookieUser.departmentId,
          DEPTNAME: cookieUser.departmentName,
          COMPANYID: cookieUser.companyId,
          COMPANYNAME: cookieUser.companyName
        }
      }
    }
  },
  methods: {
    //TODO:选择知识分类
    getKnowledgeClassValue(value, callback) {
      this.searchPara.KNOWLEDGECLASS = value[0] === undefined ? '' : value[0].ID
      callback(true)
    },
    setKnowledgeClassValue(value, callback) {
      GetAllKnowledgeClass().then(response => {
        if (response) {
          callback(response.filter(o => o.ENABLE === true))
        }
      })
    },
    //TODO:选择知识类型
    getKnowledgeTypeValue(value, callback) {
      this.searchPara.KNOWLEDGETYPE = value[0] === undefined ? '' : value[0].ID
      callback(true)
    },
    setKnowledgeTypeValue(value, callback) {
      GetAllKnowledgeType().then(response => {
        if (response) {
          callback(response.filter(o => o.ENABLE === true))
        }
      })
    },
    //TODO:选择产品型号
    getProductModelValue(value, callback) {
      if (value[0] === undefined) {
        this.searchPara.Opobject = ''
        this.searchPara.Product = ''
      } else {
        if (value[0].Type <= 5) {
          this.searchPara.Product = ''
          this.searchPara.Opobject = value[0].SocialId
        } else {
          this.searchPara.Opobject = ''
          this.searchPara.Product = value[0].SocialId
        }
      }
      callback(true)
    },
    setProductModelValue(value, callback) {
      GetAllObjTypeBSMV().then(response => {
        if (response) {
          callback(response.filter(o => o.Enable === true))
        }
      })
    },
    //TODO:选择运维对象实例
    setKnowledgeDevice(value, callback) {
      GetAllGeneralSelTreeEx()
        .then(res => {
          for (let i = 0; i < res.length; i++) {
            res[i].AggrID = res[i].SocialId + '_' + this.GetObjType(res[i].Type)
          }
          callback(res)
          if (this.EditOjb.Devices != null && this.EditOjb.Devices.length > 0) {
            for (let i = 0; i < this.EditOjb.Devices.length; i++) {
              this.dataSelKnowledgeObj.idArray.push(
                this.EditOjb.Devices[i].DEVICEID +
                  '_' +
                  this.EditOjb.Devices[i].DEVICETYPE
              )
              //这里特殊处理
            }
          }
        })
        .catch(err => {
          console.log('SelKnowledgeObjSetValue err')
        })
    },
    GetKnowledgeDevice(value, callback) {
      if (value[0] === undefined) {
        this.searchPara.Device = {}
      } else {
        this.searchPara.Device = {
          ID: 0,
          KNOWLEDGEID: '',
          DEVICEID: value[0].SocialId,
          DEVICENAME: value[0].Name,
          DEVICETYPE: this.GetObjType(value[0].Type)
        }
      }
    },
    GetObjType(type) {
      if (
        Linq.from([20, 31, 21, 22, 23]).firstOrDefault(s => s == type) != null
      )
        return 0
      if (
        Linq.from([24, 25, 29, 12, 14]).firstOrDefault(s => s == type) != null
      )
        return 1
      if (
        Linq.from([16, 33, 35, 37, 39]).firstOrDefault(s => s == type) != null
      )
        return 3
      if (
        Linq.from([41, 43, 45, 47, 49]).firstOrDefault(s => s == type) != null
      )
        return 4
      return -1 //error
    }
  },
  components: {
    commonSelectComponent
  }
}
</script>

<style scoped>
.searchPanel {
  height: 100px;
  display: block;
  background-color: #f2f7ff;
}
.el-col-8 {
  margin: auto 0;
}

.searchField {
  margin: 2px 0;
}
</style>